module.exports = __webpack_public_path__ + "static/media/bg-1.19fefea7.png";